import { Disclosure, DisclosurePanel, Transition } from '@headlessui/react';

// Libs
import { MenuEntryType } from '@/lib/platform/menu/menu';

// Components
import { MenuEntry } from '@/components/layouts/LayoutPlatform/components/Menu/components/MenuEntry';
import { SubEntries } from '@/components/layouts/LayoutPlatform/components/Menu/components/SubEntries';

export type MenuEntriesProps = {
    openDropdown: string;
    setOpenDropdown: (name: string) => void;
    isMenuOpen: boolean;
    stickyMenu?: boolean;
    menuConfig: MenuEntryType[];
};

export function MenuEntries({
    openDropdown,
    setOpenDropdown,
    stickyMenu,
    isMenuOpen,
    menuConfig
}: MenuEntriesProps) {
    const toggleDropdown = (id: string) => {
        setOpenDropdown(openDropdown === id ? null : id);
    };

    return (
        <div className="flex flex-col gap-4">
            {menuConfig.map((entry) => (
                <Disclosure key={entry.name}>
                    <div className="menu-entry cursor-pointer">
                        <MenuEntry
                            entry={entry}
                            stickyMenu={stickyMenu}
                            isMenuOpen={isMenuOpen}
                            activeEntry={openDropdown}
                            setActiveEntry={toggleDropdown}
                        />
                        {'subMenuItems' in entry ? (
                            <Transition
                                show={openDropdown === entry.id}
                                enter="transition-all duration-300 ease-out"
                                enterFrom="transform grid-rows-[0fr]"
                                enterTo="transform grid-rows-[1fr]"
                                leave="transition-all duration-300 ease-out"
                                leaveFrom="transform grid-rows-[1fr]"
                                leaveTo="transform grid-rows-[0fr]">
                                <div className="grid">
                                    <DisclosurePanel className="overflow-hidden">
                                        <SubEntries
                                            subMenuItems={entry.subMenuItems}
                                            isMenuOpen={isMenuOpen}
                                            className="ml-7 mt-3"
                                        />
                                    </DisclosurePanel>
                                </div>
                            </Transition>
                        ) : null}
                    </div>
                </Disclosure>
            ))}
        </div>
    );
}
